import { RhfDatePicker, RhfTextField } from '@core/components';
import type { Order } from '../../api/order';
import { RhfCustomerSelect } from './RhfCustomerSelect';

export interface OrderDetailsFormValues {
  customer: string;
  dueDate: string;
  notes: string;
}

export const EMPTY_ORDER_DETAILS_FORM_VALUES: OrderDetailsFormValues = {
  customer: '',
  dueDate: '',
  notes: '',
};

export function orderToDetailsFormValues(
  order: Pick<Order, 'customer' | 'dueDate' | 'notes'>
): OrderDetailsFormValues {
  return {
    customer: String(order.customer?.id ?? ''),
    dueDate: order.dueDate ?? '',
    notes: order.notes ?? '',
  };
}

interface OrderDetailsFormProps {
  disabled?: boolean;
}

const OrderDetailsForm = ({ disabled = false }: OrderDetailsFormProps) => {
  return (
    <>
      <RhfCustomerSelect<OrderDetailsFormValues>
        name="customer"
        label="Name"
        required
        disabled={disabled}
      />
      <RhfDatePicker<OrderDetailsFormValues>
        name="dueDate"
        label="Due Date"
        disabled={disabled}
      />
      <RhfTextField<OrderDetailsFormValues>
        name="notes"
        label="Notes"
        disabled={disabled}
        textFieldProps={{
          multiline: true,
          rows: 3,
        }}
      />
    </>
  );
};

export default OrderDetailsForm;
